<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { RouterLink, RouterView, useRoute } from 'vue-router'
import { useSessionStore } from './stores/session'
import { usePushStore } from './stores/push'
import AppBanner from './components/AppBanner.vue'

const route = useRoute()
const session = useSessionStore()
const push = usePushStore()

const online = ref(navigator.onLine)
const showNav = computed(() => session.isAuthenticated && route.meta.hideNav !== true)

function updateOnline(): void {
  online.value = navigator.onLine
}

onMounted(() => {
  window.addEventListener('online', updateOnline)
  window.addEventListener('offline', updateOnline)
  void push.refresh()
})

onUnmounted(() => {
  window.removeEventListener('online', updateOnline)
  window.removeEventListener('offline', updateOnline)
})
</script>

<template>
  <div class="app">
    <header v-if="session.isAuthenticated" class="app-header">
      <RouterLink class="brand" :to="{ name: 'dashboard' }">
        <img src="/icon.svg" alt="" width="26" height="26" />
        <span>Reisepilot</span>
      </RouterLink>
      <span class="spacer"></span>
      <span v-if="route.meta.title" class="tiny muted">{{ route.meta.title }}</span>
    </header>

    <main class="app-main">
      <AppBanner v-if="!online" tone="warning" glyph="⚡" style="margin-bottom: 1rem">
        Keine Verbindung. Angezeigte Werte stammen aus dem Zwischenspeicher und können veraltet sein.
      </AppBanner>
      <RouterView />
    </main>

    <nav v-if="showNav" class="app-nav" aria-label="Hauptnavigation">
      <RouterLink :to="{ name: 'dashboard' }"><span class="glyph" aria-hidden="true">◎</span>Start</RouterLink>
      <RouterLink :to="{ name: 'scan' }"><span class="glyph" aria-hidden="true">＋</span>Scannen</RouterLink>
      <RouterLink :to="{ name: 'train' }"><span class="glyph" aria-hidden="true">▤</span>Zug</RouterLink>
      <RouterLink :to="{ name: 'devices' }"><span class="glyph" aria-hidden="true">◈</span>Standort</RouterLink>
      <RouterLink :to="{ name: 'map' }"><span class="glyph" aria-hidden="true">◇</span>Karte</RouterLink>
      <RouterLink :to="{ name: 'settings' }"><span class="glyph" aria-hidden="true">⚙</span>Einstellungen</RouterLink>
    </nav>
  </div>
</template>
